import { render, staticRenderFns } from "./PartneredOrgsModal.vue?vue&type=template&id=6b8485c6&"
import script from "./PartneredOrgsModal.vue?vue&type=script&lang=js&"
export * from "./PartneredOrgsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports